import { motion } from "framer-motion"
import "./ValidationAnimation.css"

const extractPathCoordinates = (pathString) => {
    // Match all coordinate pairs (number number) in the path string
    const coordRegex = /(\d+\.?\d*)\s+(\d+\.?\d*)/g;
    const matches = [...pathString.matchAll(coordRegex)];
    
    // Convert matches to coordinate objects
    return matches.map(match => ({
        x: parseFloat(match[1]),
        y: parseFloat(match[2])
    }));
};

const ValidationAnimation = () => {
    // Path for magnifying glass - handle first, then circle
    const pathString = "M 60 60 L 45 45 L 47 43 L 45 45 A 22.5 22.5 0 1 1 52 30"
    const coordinates = extractPathCoordinates(pathString);
    
    return (
        <div style={{ position: "relative", width: "64px", height: "64px" }}>
            <svg 
                xmlns="http://www.w3.org/2000/svg" 
                width="64" 
                height="64"
                style={{ position: "absolute", top: 0, left: 0 }}
            >
                <motion.path
                    d={pathString}
                    fill="transparent"
                    strokeWidth="8"
                    stroke="var(--blue)"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    initial={{ pathLength: 0.001, opacity: 0 }}
                    animate={{ pathLength: 1, opacity: 1 }}
                    transition={{
                        pathLength: {
                            delay: 3.75,
                            type: "tween",
                            duration: 1.2,
                            ease: "easeOut"
                        },
                        opacity: { 
                            duration: 0.01, 
                            delay: 3.75
                        }
                    }}
                />
                
                {/* Uncomment to see points at path coordinates */}
                {/* {coordinates.map((coord, index) => (
                    <circle 
                        key={index}
                        cx={coord.x}
                        cy={coord.y}
                        r="2"
                        fill="red"
                    />
                ))} */}
            </svg>
        </div>
    );
}

export default ValidationAnimation;
